module.exports = __webpack_public_path__ + "img/CG1_51.192e5d0.png";